import { failureHandler, successHandler } from './responseHandlers'
import setHeaders from './setHeaders'

const customFetch = ({ payload, url, verb }) =>
  globalThis.fetch(url, {
    body: JSON.stringify(payload),
    headers: setHeaders(),
    method: verb,
  })

export default (parameters) =>
  customFetch(parameters)
    .then(successHandler)
    .catch((error) => failureHandler(error, parameters))
